<template>
  <div v-if="isOffline" class="pwa-offline-container">
    <v-card class="pwa-offline-card" elevation="4">
      <v-card-text class="text-center">
        <v-icon size="64" color="warning" class="mb-4">
          mdi-wifi-off
        </v-icon>
        <h2 class="text-h5 mb-3">You're Offline</h2>
        <p class="text-body-1 mb-4">
          Don't worry! You can still use most features of SupportApp while offline.
        </p>
        <v-btn
          color="primary"
          variant="elevated"
          @click="retryConnection"
          :loading="retrying"
        >
          Try Again
        </v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup lang="ts">
const isOffline = ref(false)
const retrying = ref(false)

// Check online/offline status
const updateOnlineStatus = () => {
  if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
    isOffline.value = !navigator.onLine
  }
}

onMounted(() => {
  updateOnlineStatus()
  if (typeof window !== 'undefined') {
    window.addEventListener('online', updateOnlineStatus)
    window.addEventListener('offline', updateOnlineStatus)
  }
})

onUnmounted(() => {
  if (typeof window !== 'undefined') {
    window.removeEventListener('online', updateOnlineStatus)
    window.removeEventListener('offline', updateOnlineStatus)
  }
})

// Retry connection
const retryConnection = async () => {
  retrying.value = true
  try {
    // Try to fetch a small resource to check connectivity
    await fetch('/favicon.ico', { method: 'HEAD' })
    isOffline.value = false
  } catch (error) {
    console.log('Still offline')
  } finally {
    retrying.value = false
  }
}
</script>

<style scoped>
.pwa-offline-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.pwa-offline-card {
  max-width: 400px;
  width: 100%;
  border-radius: 12px;
}
</style> 